export enum BrandAmbassadorEnum {
  BrandAmbassadorDesc = 'Tymka\xa0Kucharczyka',
  BrandAmbassadorTitle = 'Mubi\xa0wspiera',
}
